// eslint-disable-next-line no-unused-vars
import { h } from 'preact';
import PropTypes from 'prop-types';
import ItemList from './ItemList';

/**
 * The main component.
 *
 * @param {Object} props Props
 * @return {Object} JSX
 */
const SingleItemList = ( props ) => {
	const { group, items, label } = props;

	// Render component.
	return <ItemList type="radio" group={group} items={items} label={label} />;
};

SingleItemList.propTypes = {
	group: PropTypes.string.isRequired,
	items: PropTypes.arrayOf( PropTypes.object ).isRequired,
	label: PropTypes.string.isRequired,
};

export default SingleItemList;
